export enum ChallengeStatusTagType {
  OPEN = 'open',
  COMING_SOON = 'coming-soon',
  CLOSED = 'closed',
  DRAFT = 'draft',
}
